import React, { useRef, useState } from 'react';

const SmsDigitInput = ({ onComplete, disabled = false, error = false }) => {
    const [digits, setDigits] = useState(Array(6).fill(''));
    const refs = useRef([]);

    const handleChange = (index, value) => {
        if (!/^\d?$/.test(value)) return;
        const next = [...digits];
        next[index] = value;
        setDigits(next);
        if (value && index < 5) {
            refs.current[index + 1]?.focus();
        }
        if (next.every(d => d !== '') && next.length === 6) {
            onComplete(next.join(''));
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !digits[index] && index > 0) {
            refs.current[index - 1]?.focus();
        }
    };

    const borderClass = error ? 'border-red-500' : 'border-lightblue focus:border-orange';

    return (
        <div className="flex justify-center gap-2">
            {digits.map((digit, i) => (
                <input
                    key={i}
                    ref={(el) => { refs.current[i] = el; }}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={digit}
                    disabled={disabled}
                    onChange={(e) => handleChange(i, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(i, e)}
                    className={`w-10 h-11 text-center text-lg font-bold bg-deepblue text-white border rounded focus:outline-none ${borderClass} disabled:opacity-50`}
                    aria-label={`Digit ${i + 1}`}
                />
            ))}
        </div>
    );
};

export default SmsDigitInput;
